import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/users',
            name: 'users',
            component: () => import("./views/users.vue")
        }
    ];
};